import BaseViewController from "./base-view-controller";

class AccountInvoicesListViewController extends BaseViewController {
  fetchPdf(url, body, fileName) {
    this.appData.fetchPostFile({
      openInNewTab: !this.appData.disableAttachmentsInNewTab,
      url,
      preparedData: body,
      fileName
    });
  }

  handleButtonClick(name, selectedData, action, field) {
    const {
      action: { value: url }
    } = this.screen;
    this.fetchPdf(url, { selectedData }, field?.childrenData?.name);
  }
}

export default AccountInvoicesListViewController;
